import type { SubscriptionEntityType } from 'src/api/subscriptionsApi';

export type SubscriptionCycle = 'monthly' | 'yearly';

export type PackageIncludedProduct = {
  id: string;
  name: string;
  solution?: string;
  permissionIds: string[];
};

export type CatalogueItem = {
  id: string;
  label: string;
  value: string;
  entityType: SubscriptionEntityType;
  domain?: string;
  solution?: string;
  permissionIds: string[];
  msrpKind: SubscriptionCycle | null;
  includedProducts?: PackageIncludedProduct[];
};

export type SubscriptionLineItem = {
  productId: string;
  licenses: number;
};

export type SubscriptionCreateFormValues = {
  customerReference: string;
  internalNotes: string;
  items: SubscriptionLineItem[];
};

export type SubscriptionCreateDraft = Omit<SubscriptionCreateFormValues, 'items'> & {
  clientId: string;
  clientName: string;
  subscriptionType: SubscriptionCycle;
  items: Array<
    SubscriptionLineItem & {
      name: string;
      entityType: SubscriptionEntityType;
    }
  >;
};

export const MIN_LICENSES = 1;
export const MAX_LICENSES = 10000;
export const DEFAULT_LICENSES = 1;
